var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.7,
    height: 19.7,
    viewBox: "0 0 17.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(-3.15 -3.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M18,22.85H6A2.853,2.853,0,0,1,3.15,20V12a.85.85,0,1,1,1.7,0v8A1.151,1.151,0,0,0,6,21.15H18A1.151,1.151,0,0,0,19.15,20V12a.85.85,0,0,1,1.7,0v8A2.853,2.853,0,0,1,18,22.85Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M16,6.85a.847.847,0,0,1-.6-.249L12,3.2,8.6,6.6A.85.85,0,0,1,7.4,5.4l4-4a.85.85,0,0,1,1.2,0l4,4A.85.85,0,0,1,16,6.85Z",
    transform: "translate(24 19) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M12,15.85a.85.85,0,0,1-.85-.85V2a.85.85,0,0,1,1.7,0V15A.85.85,0,0,1,12,15.85Z",
    transform: "translate(24 19) rotate(180)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.97d143cc9e641ac56bcaa66da8d1f2b8.svg";
export { ForwardRef as ReactComponent };